import request from '@/utils/request'

const api_name = '/portal/web/api/studentApply'

export default {
    validateInviteCode(code) {
        return request({
            url: api_name + '/validateCode?code=' + code,
            method: 'get'
        })
    },
    getSchoolInfo(inviteCode) {
        return request({
            url: api_name + '/schoolInfo?inviteCode=' + inviteCode,
            method: 'get'
        })
    },
    submitApply(formData) {
        return request({
            url: api_name + '/submit',
            method: 'post',
            data: formData
        })
    }
}
